<template>
  <div class="md-card agendaItem" :class="{ 'recommended-border': item.isRecommended}">
    <div class="statuses mr-auto" style="padding-left:4px; display: flex; align-items: center; width: 100%;">
      <div v-if="showLogo && item.partners.length>0" style="display: flex; align-items: center;">
        <span class="text-primary regular" style="font-size:18px; margin-right: 6px;">{{$t(`Partners`)}}:</span>
        <img v-for="partner in uniquePartnersByExternalId"
          :key="partner.id"
          :src="logotypeUrl(partner.description.logoId)"
          style="width: auto; max-height:40px !important; margin-left: 6px; border-radius: 0%;"
        />
      </div>
      <div style="display: flex; margin-left: auto;">
        <md-icon
          class="text-primary"
          style="font-size:22px !important;margin-left:0px"
          v-if="item.isRecommended"
        >star</md-icon>
        <md-icon class="text-primary" style="font-size:22px !important" v-if="item.isMine">person</md-icon>

        <template v-if="isLoggedIn">
        <md-button
          v-if="item.isLiked"
          class="md-primary md-just-icon md-simple"
          @click="onLike(false)"
        >
          <md-icon style="font-size:22px !important">add_circle</md-icon>
        </md-button>
        <md-button v-else class="md-primary md-just-icon md-simple" @click="onLike(true)">
          <md-icon style="font-size:22px !important">add_circle_outline</md-icon>
        </md-button>
        </template>
      </div>
      
    </div>

    <h3
      v-if="bigHeader"
      class="text-primary bold"
      style="margin:0px 0px 6px 5px"
    >{{item.description.topic}}</h3>
    <div
      v-else
      class="text-primary regular"
      style="font-size:18px;margin-left:5px;margin-bottom:6px"
    >{{item.description.topic}}</div>

    <div v-if="showThematicPath" class="regular" style="font-size:14px;">
      <span v-if="panelIcon" :style="trackIconStyle"></span>
      {{item.description.thematicPath}}
    </div>

    <div
      style="font-size:14px;margin-top:20px"
      class="text-gray regular"
      v-if="(showDate && agendaSettings.showDate) || agendaSettings.showTime"
    >
      <md-icon>schedule</md-icon>
      <span
        v-if="showDate && agendaSettings.showDate"
      >{{item.startDate | moment(agendaSettings.showTime ? "YYYY-MM-DD, " : "YYYY-MM-DD") }}</span>

      <span
        v-if="agendaSettings.showTime"
      >{{item.startDate | moment("HH:mm")}} - {{item.endDate | moment("HH:mm")}}</span>
    </div>
    <div v-if="localisation" style="font-size:14px" class="text-gray regular">
      <md-icon>room</md-icon>
      <span>{{localisation}}</span>
    </div>
    <div
      v-if="showDescription && item.description.description"
      class="text-gray regular"
      style="font-size:14px; margin:5px 10px 10px 5px"
    >{{item.description.description}}</div>
    <div class="md-layout md-layout-item md-size-100" v-if="showDetailsLink">
      <div class="ml-auto">
      <md-button
      v-if="hasChatAccess"
          @click="sharePanel"
          class="md-round md-primary md-sm md-blue-border"
          style="margin:5px 10px"
        >{{$t('Share')}}</md-button>


        <md-button
          @click.prevent="$router.push({ name: 'panelDetails', params: { id: item.id }})"
          class="md-round md-primary md-sm md-blue-border"
          style="margin:5px 10px"
        >{{$t('Go to details')}}</md-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "@/util/axios";
import { getIconByKey, DEFAULT_COLOR } from "@/util/filters/panel-icon";

export default {
  props: [
    "item",
    "showDate",
    "showThematicPath",
    "showDetailsLink",
    "showDescription",
    "bigHeader",
    "showLogo"
  ],
  computed: {
    ...mapGetters({
       isLoggedIn: "user/isLoggedIn",
      conference: "conference/current",
      language: "language/current",
      agendaSettings: "user/agendaSettings",
      hasChatAccess: "user/hasChatAccess"
    }),
    
    uniquePartnersByExternalId() {
    const seenExternalIds = new Set();
    return this.item.partners.filter(partner => {
      const externalId = partner.description.externalID;
      if (seenExternalIds.has(externalId)) return false;
      seenExternalIds.add(externalId);
      return true;
    });
    },
    
    localisation() {

      let b = this.item.description.building;
      let r = this.item.description.room;

      let localisation = b;

      if (localisation && r) {
        localisation += ", " + this.item.description.room;
      } else if (r) {
        localisation = this.item.description.room;
      }

      return localisation;
    },

    trackColor() {
      return this.item.description.thematicPathColor || null;
    },
    effectiveTrackColor() {
      return this.trackColor || (this.item.description.thematicPath ? DEFAULT_COLOR : null);
    },
    panelIcon() {
      if (!this.item.description.thematicPath) return null;
      if (this.item.description.thematicPathIconUrl) return this.item.description.thematicPathIconUrl;
      return getIconByKey(this.item.description.thematicPathIconKey, true);
    },
    trackIconStyle() {
      const url = `url(${this.panelIcon})`;
      return {
        display: 'inline-block',
        width: '22px',
        height: '22px',
        marginRight: '5px',
        marginLeft: '5px',
        verticalAlign: 'middle',
        flexShrink: '0',
        backgroundColor: this.effectiveTrackColor,
        maskImage: url,
        maskSize: 'contain',
        maskRepeat: 'no-repeat',
        maskPosition: 'center',
        WebkitMaskImage: url,
        WebkitMaskSize: 'contain',
        WebkitMaskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
      };
    }
  },
  methods: {
    gotoDetails(id) {
      this.$router.push({ name: "panelDetails", query: { id: id } });
    },
    sharePanel(){
      this.$router.push({ 
        name: "chat", 
        params: { panel: { id: this.item.id, name: this.item.description.topic }}
      });
    },
    logotypeUrl(logoId) {
      return axios.getFileUrl(logoId);
    },
    async onLike(value) {
      let loader = this.$loading.show();
      let action = value ? "add" : "remove";
      let success = true;
      try {
        this.item.isLiked = (
          await axios.post(`public/myprofile/agenda/favourites/${action}`, {
            id: this.item.id
          })
        ).data;
      } catch {
        success = false;
      } finally {
        if (success) {
          let text = value
            ? this.$t("Added to My Agenda")
            : this.$t("Removed to My Agenda");
          this.$swal({
            icon: "success",
            text: text
          });
        }

        loader.hide();
      }
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped >
.recommended-border {
  border: 5px solid #3678b6;
}

div.statuses {
  margin: 5px 0px 10px 0px;
}

.statuses .md-button.md-just-icon {
  height: 22px;
  min-width: 0px;
  width: 24px;
  padding: 0px;
  margin: 0px;
  overflow: hidden;
  position: relative;
}

.statuses .md-button .md-ripple {
  padding: 0px !important;
  display: flex;
  justify-content: center;
  align-items: center;

  .md-icon {
    padding: 0px !important;
  }
}

.md-card {
  padding: 10px;
  margin: 20px 0px 20px 0px;
  background: #ffffff;
  box-shadow: 0px 0px 30px #0000001a;
  border-radius: 15px;
  opacity: 1;
}

.md-card .md-card-content {
  padding: 0px;
  line-height: inherit;
}

.md-collapse-content p {
  margin-bottom: 10px;
  padding-top: 0px;
  padding-bottom: 0px;
}
</style>